import { useState, useCallback } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Accordion from '@mui/material/Accordion';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import { CONFIG } from 'src/global-config';
import { useLocale } from 'src/locales';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';

// ----------------------------------------------------------------------

const dataDescription = [
  'Our_vision_is_to_become_the_leading_reference_platform_for_enterprise',
  'Our_mission_is_to_empower_businesses_with_reliable_and_integrated_digital_transport_solutions',
  'Delivering_consistent_quality_and_dependable_performance_in_every_operation',
  'Managing_transport_processes_through_structured_planning_and_precise_execution',
  'Maintaining_clarity_in_contracts_pricing_and_reporting_to_foster_mutual_trust',
  'Continuously_enhancing_our_platform_to_drive_intelligent_transformation_in_logistics',
  'Enabling_our_teams_and_clients_to_achieve_their_goals_through_effective_digital_tools_and_integrated_support',
];
const data = [
  'Our_vision',
  'Our_mission',
  'Reliability',
  'Operational_Discipline',
  'Transparency',
  'Innovation',
  'Empowerment',
].map((question, index) => ({
  question,
  answer: dataDescription[index],
}));

export function AboutStoryInnovation({ sx, ...other }) {
  const { t } = useLocale();
  const [expanded, setExpanded] = useState(false);

  const handleChangeExpanded = useCallback(
    (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    },
    []
  );

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const imgSrc = isSmallScreen
    ? `${CONFIG.assetsDir}/assets/images/home/seo/About-Shahen/vision-mission-mobile.webp`
    : `${CONFIG.assetsDir}/assets/images/home/seo/About-Shahen/vision-mission.webp`;

  const renderFaqs = () => (
    <>
      {data?.map((item, index) => (
        <Accordion
          key={index}
          expanded={expanded === item?.question}
          onChange={handleChangeExpanded(item?.question)}
          disableGutters
          sx={{ py: 0.5 }}
        >
          <AccordionSummary>
            <Box component="span" sx={{ typography: 'h6' }}>
              {t(item?.question)}
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ color: 'text.secondary' }}>{t(item?.answer)}</AccordionDetails>
        </Accordion>
      ))}
      <Divider />
    </>
  );

  const renderImage = () => (
    <Box
      component="img"
      alt={t('about-img-title')}
      title={t('about-img-meta-desk')}
      src={imgSrc}
      sx={{
        display: 'block',
        width: '100%',
        height: 480,
        borderRadius: 2,
        maxWidth: { xs: 300, sm: 350, md: 480 },
        mx: 'auto',
        maxHeight: { xs: 200, sm: 300, md: 480 },
        objectFit: 'cover',
        objectPosition: 'center center',
      }}
    />
  );

  return (
    <Box
      component="section"
      sx={[
        {
          pt: 10,
          pb: { xs: 5, md: 10 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Grid container spacing={3} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
          <Grid size={{ xs: 12, md: 6, lg: 6 }}>
            {/* {renderTexts()} */}
            {renderFaqs()}
          </Grid>

          <Grid size={{ xs: 12, md: 6, lg: 5 }}>{renderImage()}</Grid>
        </Grid>
      </Container>
    </Box>
  );
}
